import request from '@/config/axios'
export const getPage = (params: any) => request.get({ url: '/hotel/team-booking/page', params })
export const getDetail = (id: string | number) => request.get({ url: '/hotel/team-booking/detail', params: { id } })
export const create = (data: any) => request.post({ url: '/hotel/team-booking/create', data })
export const operate = (id: string | number, operation: string) => request.put({ url: `/hotel/team-booking/${operation}`, params: { id } })
